export interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

type PlaceDetails = { address_components?: AddressComponent[] } | null;
type PlacesService = {
  getDetails: (
    request: { placeId: string; fields: string[] },
    callback: (place: PlaceDetails, status: string) => void
  ) => void;
};
type PlacesWindow = Window & {
  google?: {
    maps?: {
      places?: { PlacesService: new (container: HTMLElement) => PlacesService };
    };
  };
};

/** Fetch only address fields from the selected Places prediction, never coordinates. */
export function placeAddressComponents(placeId: string): Promise<AddressComponent[]> {
  return new Promise((resolve, reject) => {
    const maps = (window as PlacesWindow).google?.maps;
    if (!placeId || !maps?.places?.PlacesService) {
      reject(new Error('Address details are unavailable.'));
      return;
    }

    const service: PlacesService = new maps.places.PlacesService(document.createElement('div'));
    service.getDetails({ placeId, fields: ['address_components'] }, (place, status) => {
      if (status === 'OK' && place?.address_components) {
        resolve(place.address_components);
      } else {
        reject(new Error('Could not load the selected address.'));
      }
    });
  });
}
